import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import DatePicker from "src/components/common/calendar/DatePicker";
import { searchDateSingleFormString, searchFormString, gridCalendarWidth, gridCalendarHeight, gridCalendarLayoutHeight } from "src/components/common/common";
import { formatDate, formatDateMonth, formatDateYear4 } from "src/utils/string/stringUtil";
import { searchLabelStyle } from "src/components/common/common";
import { searchDateRangeFormString } from "src/components/common/common";

interface Props {
	label: string;
	visible: boolean;
	setVisible: (visible: boolean) => void;
    value?: Date;
	editable?: boolean;
    onChange: (date: Date | undefined) => void;
	pickerPosition: { top: number; left: number };		setPickerPosition: (pickerPosition: { top: number; left: number }) => void;
	//년월만 보여주기 선택 가능 여부
	yearMonthVisible?: boolean;
	//시간 선택 가능 여부
	timeEditable?: boolean;
	wrapperOption?: {
		wrapperStyle?: string;
		titleStyle?: string;
		dateRangeStyle?: string;
	};
}

export const SearchDateSingleForm = ( props: Props ) => {

    const { 
		label, 
		visible, setVisible,
		value, 
		editable = true,
		onChange,
		pickerPosition, setPickerPosition,
		yearMonthVisible = false,
		timeEditable = false,
		wrapperOption = {
			wrapperStyle: "w-[180px] min-w-[180px] mr-[10px] mr-10",
			titleStyle: 'h-[24px] flex items-center truncate shrink-0' ,
			dateRangeStyle: searchDateRangeFormString,
		},
	} = props;

	const inputRef = useRef<HTMLDivElement>(null);

	// 출고일자 입력란 클릭 시 위치 계산
	const handleDateInputClick = () => {
		if (inputRef.current) {
			const rect = inputRef.current.getBoundingClientRect();
			setPickerPosition({ top: rect.bottom + 4, left: rect.left });
		}
		if (editable) {
			setVisible(true);
		}
	};


    return (
		<div className={`${searchFormString} cursor-pointer ${wrapperOption?.wrapperStyle || "w-[300px]"}`}
				onClick={handleDateInputClick}
			>
			<p className={`h-[24px] flex items-center truncate flex-shrink-0 ${wrapperOption?.titleStyle || ""}`}>
				{label}
			</p>
			<p	ref={inputRef} 
				className={`
					${ searchDateSingleFormString }
					cursor-pointer
					${editable ? 'bg-white' : 'bg-gray-100'}
					${wrapperOption?.dateRangeStyle || ""}
					`}
				onClick={(e) =>{ e.stopPropagation(); handleDateInputClick() }}
				>
				{value ? 
					(yearMonthVisible ?
						formatDateYear4(value) + '-' + formatDateMonth(value) : formatDate(value)
					) : ""}
				 {/* : {editable ? 'true' : 'false'} */}
			</p>
			{visible && editable &&
				ReactDOM.createPortal(
				<>
				<div
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: gridCalendarWidth,
						height: gridCalendarLayoutHeight,
						zIndex: 9998,
						// backgroundColor: 'rgba(0,0,0,0.1)', // 필요시 반투명 배경 추가
					}}
					onClick={(e) => {
						e.stopPropagation();
						setVisible(false);
					}}
					/>
					<div style={{
								position: 'absolute',
								top: `${pickerPosition.top}px`,
								left: `${pickerPosition.left}px`,
								zIndex: 9999, // DateRangePicker z-index
							}}
							onClick={(e) => e.stopPropagation()}
						>
						<DatePicker
							value={value}
							onChange={(date) => {
								onChange(date);
							}}
							onReset={() => {
								const today = new Date();
								onChange(new Date(today.getFullYear(), today.getMonth(), today.getDate()));
								setVisible(false);
							}}
							onConfirm={(date: Date | undefined) => {
								if(date) {
									onChange(date);
								}
								setVisible(false);
							}}
							yearMonthVisible={yearMonthVisible}
							timeEditable={timeEditable}
						/>
					</div>
				</>
				, document.body)
			}
		</div>
	)
}